<div class="flex gap-0 md:gap-10 flex-col items-center md:flex-row md:justify-around w-full mb-10 md:mb-0">
  <h1 class="text-4xl text-blue1 xl:w-1/3 text-center">
    {{title}}
  </h1>
  <psc-line class="w-5/6 mt-4 mb-8 block md:hidden"></psc-line>
  <div class="flex gap-10 flex-col xl:flex-row items-center">
    <ng-content></ng-content>
    <!--  Save power plant  -->
    <ng-container *ngIf="!hideSavePlant">
        <psc-save-power-plant
          [calculatorResultWrapper]="calculationResultWrapper"></psc-save-power-plant>
    </ng-container>

    <!--  Download PDF  -->
    <ng-container *ngIf="!hidePdfDownload">
      <ng-container *ngIf="showPdfRolesOnly && showPdfRolesOnly.length > 0; else noRolesForShowPdf">
        <psc-pdf-download
          [powerPlant]="powerPlant"
          [advanced]="advancedPdfDownload"
          *pscRoleAccess="showPdfRolesOnly"
          [calculatorResultWrapper]="calculationResultWrapper"></psc-pdf-download>
      </ng-container>
      <ng-template #noRolesForShowPdf>
        <psc-pdf-download
          [powerPlant]="powerPlant"
          [advanced]="advancedPdfDownload"
          [calculatorResultWrapper]="calculationResultWrapper"></psc-pdf-download>
      </ng-template>
    </ng-container>
  </div>
</div>
<psc-line class="w-full mt-6 mb-10 hidden md:block"></psc-line>
